<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.roleName"
        placeholder="角色名称"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="handleFilter"
      />
      <el-select v-model="listQuery.status" placeholder="状态" class="filter-item" style="width: 120px;" clearable>
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        搜索
      </el-button>
      <el-button
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
      >
        添加
      </el-button>
    </div>

    <el-table
      :key="tableKey"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="角色名称" min-width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.roleName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="角色代码" width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.roleCode }}</span>
        </template>
      </el-table-column>
      <el-table-column label="描述" min-width="200" align="center">
        <template slot-scope="{row}">
          <span>{{ row.description }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" class-name="status-col" width="100" align="center">
        <template slot-scope="{row}">
          <el-tag :type="row.status | statusFilter">
            {{ row.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.createTime | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="140" class-name="small-padding fixed-width">
        <template slot-scope="{row,$index}">
          <el-dropdown trigger="click" @command="command => handleAction(command, row, $index)">
            <el-button type="primary" size="mini">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit">编辑</el-dropdown-item>
              <el-dropdown-item command="menu">菜单</el-dropdown-item>
              <el-dropdown-item v-if="row.status === 0" command="enabled">启用</el-dropdown-item>
              <el-dropdown-item v-if="row.status === 1" command="disabled">禁用</el-dropdown-item>
              <el-dropdown-item divided command="delete">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.size" @pagination="getList" />

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" class="common-dialog">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="100px" class="common-dialog-form">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="temp.roleName" placeholder="请输入角色名称" />
        </el-form-item>
        <el-form-item label="角色代码" prop="roleCode">
          <el-input v-model="temp.roleCode" placeholder="请输入角色代码" />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="temp.description" type="textarea" :rows="3" placeholder="请输入角色描述" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="temp.status" class="filter-item" placeholder="请选择状态">
            <el-option v-for="item in statusOptions" :key="item.key" :label="item.display_name" :value="item.key" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
          确认
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="分配菜单权限" :visible.sync="menuDialogVisible" width="520px" class="common-dialog">
      <el-form label-position="left" label-width="90px" class="common-dialog-form">
        <el-form-item label="角色名称">
          <el-input v-model="menuRoleName" disabled />
        </el-form-item>
        <el-form-item label="角色标识">
          <el-input v-model="menuRoleCode" disabled />
        </el-form-item>
        <el-form-item label="菜单权限">
          <div class="menu-tree-actions">
            <el-checkbox v-model="menuExpandAll" @change="handleMenuExpandAll">展开/折叠</el-checkbox>
            <el-checkbox v-model="menuCheckAll" @change="handleMenuCheckAll">全选/全不选</el-checkbox>
          </div>
          <el-input
            v-model="menuFilterText"
            size="small"
            placeholder="输入菜单名称过滤"
            clearable
            class="menu-tree-filter"
          />
          <el-tree
            ref="menuTreeRef"
            :data="menuTreeData"
            :props="menuTreeProps"
            node-key="id"
            show-checkbox
            :check-strictly="true"
            :default-expand-all="menuExpandAll"
            :filter-node-method="filterMenuNode"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="menuDialogVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="handleUpdateMenu">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRoleList, createRole, updateRole, deleteRole, getRoleMenus, updateRoleMenus } from '../../../api/role'
import { getMenuList } from '../../../api/menu'
import waves from '../../../directive/waves' // waves directive
import Pagination from '../../../components/Pagination' // secondary package based on el-pagination

export default {
  name: 'RoleTable',
  components: { Pagination },
  directives: { waves },
  filters: {
    statusFilter(status) {
      const statusMap = {
        1: 'success',
        0: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        roleName: undefined,
        status: undefined
      },
      statusOptions: [
        { key: 1, display_name: '启用' },
        { key: 0, display_name: '禁用' }
      ],
      temp: {
        id: undefined,
        roleName: '',
        roleCode: '',
        description: '',
        status: 1
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑角色',
        create: '创建角色'
      },
      dialogPvVisible: false,
      pvData: [],
      menuDialogVisible: false,
      menuTreeData: [],
      menuTreeProps: {
        children: 'children',
        label: 'menuName'
      },
      menuFilterText: '',
      menuExpandAll: true,
      menuCheckAll: false,
      menuRoleId: undefined,
      menuRoleName: '',
      menuRoleCode: '',
      rules: {
        roleName: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }],
        roleCode: [{ required: true, message: '角色代码不能为空', trigger: 'blur' }]
      },
      downloadLoading: false
    }
  },
  created() {
    this.getList()
  },
  watch: {
    menuFilterText(value) {
      if (this.$refs.menuTreeRef) {
        this.$refs.menuTreeRef.filter(value)
      }
    }
  },
  methods: {
    handleAction(command, row, index) {
      switch (command) {
        case 'edit':
          this.handleUpdate(row)
          break
        case 'menu':
          this.handleManageMenu(row)
          break
        case 'enabled':
          this.handleModifyStatus(row, 'enabled')
          break
        case 'disabled':
          this.handleModifyStatus(row, 'disabled')
          break
        case 'delete':
          this.handleDelete(row, index)
          break
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      const data = {
        page: this.listQuery.page - 1,
        size: this.listQuery.size
      }
      if (this.listQuery.roleName) {
        data.roleName = this.listQuery.roleName
      }
      if (this.listQuery.status !== undefined && this.listQuery.status !== null && this.listQuery.status !== '') {
        data.status = this.listQuery.status
      }
      getRoleList(data).then(response => {
        this.list = response.data.content
        this.total = response.data.totalElements

        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        roleName: '',
        roleCode: '',
        description: '',
        status: 1
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          createRole(this.temp).then(() => {
            this.getList()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          updateRole(tempData).then(() => {
            this.getList()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    handleModifyStatus(row, status) {
      const statusText = status === 'enabled' ? '启用' : '禁用'
      const newStatus = status === 'enabled' ? 1 : 0
      this.$confirm(`此操作将${statusText}该角色, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const tempData = Object.assign({}, row)
        tempData.status = newStatus
        updateRole(tempData).then(() => {
          this.getList()
          this.$notify({
            title: '成功',
            message: `${statusText}成功`,
            type: 'success',
            duration: 2000
          })
        })
      })
    },
    handleDelete(row, index) {
      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRole(row.id).then(() => {
          this.list.splice(index, 1)
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
        })
      })
    }
    ,
    async handleManageMenu(row) {
      this.menuRoleId = row.id
      this.menuRoleName = row.roleName
      this.menuRoleCode = row.roleCode
      this.menuFilterText = ''
      this.menuCheckAll = false
      this.menuExpandAll = true
      this.menuTreeData = []
      this.menuDialogVisible = true
      await this.loadMenuTree()
      this.$nextTick(() => {
        if (this.$refs.menuTreeRef) {
          this.$refs.menuTreeRef.setCheckedKeys([])
        }
      })
      await this.loadRoleMenus(row.id)
    },
    async loadMenuTree() {
      const list = await this.fetchAllMenus()
      this.menuTreeData = this.buildTree(list)
    },
    async loadRoleMenus(roleId) {
      const response = await getRoleMenus(roleId)
      const data = response.data || []
      const list = Array.isArray(data)
        ? data
        : (Array.isArray(data.content) ? data.content : (Array.isArray(data.menus) ? data.menus : []))
      const menuIds = this.collectMenuIds(list)
      this.$nextTick(() => {
        if (this.$refs.menuTreeRef) {
          this.$refs.menuTreeRef.setCheckedKeys(menuIds)
        }
      })
    },
    collectMenuIds(list, acc = []) {
      list.forEach(item => {
        if (item && item.id !== undefined && item.id !== null) {
          acc.push(item.id)
        }
        const children = item && Array.isArray(item.children) ? item.children : []
        if (children.length > 0) {
          this.collectMenuIds(children, acc)
        }
      })
      return acc
    },
    collectMenuLeafIds(list, acc = []) {
      list.forEach(item => {
        const children = item && Array.isArray(item.children) ? item.children : []
        if (children.length === 0) {
          if (item && item.id !== undefined && item.id !== null) {
            acc.push(item.id)
          }
        } else {
          this.collectMenuLeafIds(children, acc)
        }
      })
      return acc
    },
    filterLeafIdsByTree(ids) {
      const idMap = this.buildMenuNodeMap(this.menuTreeData)
      return ids.filter(id => {
        const node = idMap[id]
        return node && (!node.children || node.children.length === 0)
      })
    },
    buildMenuNodeMap(nodes, map = {}) {
      nodes.forEach(node => {
        map[node.id] = node
        if (node.children && node.children.length > 0) {
          this.buildMenuNodeMap(node.children, map)
        }
      })
      return map
    },
    async fetchAllMenus(page = 0, size = 1000, acc = []) {
      const response = await getMenuList({ page, size })
      const content = (response.data && response.data.content) ? response.data.content : []
      const totalPages = response.data && response.data.totalPages !== undefined
        ? response.data.totalPages
        : 1
      const nextAcc = acc.concat(content)
      if (page + 1 < totalPages) {
        return this.fetchAllMenus(page + 1, size, nextAcc)
      }
      return nextAcc
    },
    buildTree(list, parentId = null) {
      const nodes = list
        .filter(item => item.parentId === parentId)
        .map(item => ({ ...item }))
        .sort((a, b) => {
          const ao = a.orderNum
          const bo = b.orderNum
          const aHas = ao !== null && ao !== undefined
          const bHas = bo !== null && bo !== undefined
          if (aHas && bHas && ao !== bo) return ao - bo
          if (aHas !== bHas) return aHas ? -1 : 1
          return (a.id || 0) - (b.id || 0)
        })

      for (const node of nodes) {
        const children = this.buildTree(list, node.id)
        if (children.length > 0) {
          node.children = children
        }
      }
      return nodes
    },
    handleMenuExpandAll(val) {
      const tree = this.$refs.menuTreeRef
      if (!tree) return
      const toggle = (nodes) => {
        nodes.forEach(node => {
          tree.store.nodesMap[node.id] && (tree.store.nodesMap[node.id].expanded = val)
          if (node.children && node.children.length > 0) toggle(node.children)
        })
      }
      toggle(this.menuTreeData)
    },
    handleMenuCheckAll(val) {
      if (!this.$refs.menuTreeRef) return
      if (val) {
        const allKeys = this.menuTreeData.map(node => node.id)
        this.$refs.menuTreeRef.setCheckedKeys(allKeys, false)
      } else {
        this.$refs.menuTreeRef.setCheckedKeys([])
      }
    },
    filterMenuNode(value, data) {
      if (!value) return true
      return (data.menuName || '').toLowerCase().includes(value.toLowerCase())
    },
    handleUpdateMenu() {
      const tree = this.$refs.menuTreeRef
      if (!tree) return
      const menuIds = tree.getCheckedKeys()
      updateRoleMenus({ roleId: this.menuRoleId, menuIds }).then(() => {
        this.menuDialogVisible = false
        this.$notify({
          title: '成功',
          message: '菜单权限已更新',
          type: 'success',
          duration: 2000
        })
      })
    }
  }
}
</script>